'use client';

import { useState } from 'react';
import { useCookies } from 'react-cookie';

import {
  faCircle,
  faCircleCheck,
  faCircleHalfStroke,
} from '@fortawesome/pro-regular-svg-icons';

// Types
import { ThemeOption, ThemeValue } from '../../types/theme';

// Constants
import { ThemeToggle_ColourScheme_Key } from '../../constants/configuration';

// Services
import { onDropdownHeaderOpen } from '../../services/display/dropdown';

// Components
import { Box, Icon } from '@preventx/oxygen';
import { Dropdown } from '../Display/Dropdown';

type ThemeProps = {
  label: string;
  options: ThemeOption[];
};

export const Theme = ({ label, options }: ThemeProps) => {
  const [cookies, setCookie] = useCookies([ThemeToggle_ColourScheme_Key]);

  const currentColourScheme = cookies[ThemeToggle_ColourScheme_Key];

  const [state, setState] = useState<ThemeValue>(currentColourScheme ?? 'auto');

  const onClick = (theme: ThemeValue) => {
    setCookie(ThemeToggle_ColourScheme_Key, theme, { path: '/' });

    setState(theme);

    const element = document.getElementsByTagName('html')[0];
    element.setAttribute('color-scheme', theme);
  };

  if (options.length === 0) {
    return null;
  }

  return (
    <Dropdown
      ariaLabel={label}
      icon={faCircleHalfStroke}
      onOpen={onDropdownHeaderOpen}
      options={options.map(({ label, theme }) => ({
        id: `theme-selector-${theme}`,
        children: (
          <a href="#" onClick={() => onClick(theme)}>
            <Box component="div" addCluster>
              <Icon icon={state === theme ? faCircleCheck : faCircle} />
              {label}
            </Box>
          </a>
        ),
      }))}
    />
  );
};
